import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants'; 

class InvoiceDepartmentApiProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async IsDepartmentAlreadyUsed(departmentId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsDepartmentAlreadyUsed`, { departmentId });
	}
}

export const apiProvider = new InvoiceDepartmentApiProvider();
